import { call, cancel, put, takeEvery, takeLatest } from 'redux-saga/effects'
import {
  REPORTS_SHIFTS_CHANGE_DATE,
  REPORTS_SHIFTS_CHANGE_OUTLET,
  REPORTS_SHIFTS_DETAIL_HIDE,
  REPORTS_SHIFTS_DETAILS_REQUEST,
  REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST,
  REPORTS_SHIFTS_LIST_SHIFT_REQUEST,
  REPORTS_SHIFTS_PAGE_REQUEST,
  REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST,
  REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA
} from 'actions/reports/shifts/constants'
import { LOGOUT } from 'actions/constants'
import { loginOutlet } from 'sagas/api/login'
import { getFilteredDate } from 'sagas/api/get-filtered-date'
import { setCurrentOutlet } from 'actions/outlet'
import { getProfile } from 'sagas/api/profile'
import { exportShift, getShiftDetails, getShifts, getSummary } from 'sagas/api/cashdrawer/shifts'
import {
  hideShiftDetail,
  listShiftRequest,
  setCurrentPage,
  setOutlets,
  setShiftDetails,
  setShifts,
  setSummary,
  shiftSummaryRequest
} from 'actions/reports/shifts'
import { getExportedFile } from 'actions/get-exported-file'
import moment from 'moment'
import { initialize } from 'redux-form'
import * as apiOutlet from 'api/outlets'
import * as actActionBar from 'actions/actionBar'
import { showPageLoadingSpinner } from 'actions/loadingSpinner'
import * as action from 'actions'
import * as mpReportsShifts from 'mixpanel/reports/shifts'

function * getShiftSummaryAndShiftList (responseProfile, startDateFormatted, endDateFormatted) {
  yield put(setCurrentOutlet(responseProfile))
  yield put(listShiftRequest({page: 1, start: startDateFormatted, end: endDateFormatted}))
  yield put(shiftSummaryRequest({start: startDateFormatted, end: endDateFormatted}))
}

function * initForm (outlet, startDate, endDate) {
  yield put(initialize('search', {outlet, date: {startDate, endDate}}))
}

/**
 * Page flow
 */
export function * pageRequestFlow (request) {
  yield put(showPageLoadingSpinner(true))
  yield put(setShifts([]))
  yield put(setSummary({}))
  yield put(setCurrentPage(0))
  try {
    // reset shifts data
    yield put(setShiftDetails(null))

    let filteredDate = yield call(getFilteredDate)
    let startDate = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let endDate = moment(filteredDate.end_date, 'YYYY-MM-DD')
    // yield put(setDate(startDate, endDate))
    let startDateFormatted = startDate.format('D/M/YYYY')
    let endDateFormatted = endDate.format('D/M/YYYY')
    // get profile and set it to dropdown outlet
    let responseProfile = yield call(getProfile)
    yield call(getShiftSummaryAndShiftList, responseProfile, startDateFormatted, endDateFormatted)

    const resOutlet = yield call(apiOutlet.outlets)
    yield put(setOutlets(resOutlet.data))

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlet.data))
    yield put(actActionBar.setSelectedOutletIds(responseProfile.outlet_id))

    yield call(initForm, responseProfile.outlet_id, startDate, endDate)
    mpReportsShifts.reportsShiftsStart({
      outletIds: responseProfile.outlet_id,
      startDate,
      endDate
    })
  } catch (error) {

  } finally {

  }
}

export function * changeOutletShift (request) {
  yield put(setShifts([]))
  yield put(setSummary({}))
  yield put(showPageLoadingSpinner(true))
  let {payload: {outletIds, startDate, endDate, isMobile}} = request
  yield put(hideShiftDetail(isMobile))
  yield call(loginOutlet, {id: outletIds})
  yield call(initForm, outletIds, startDate, endDate)
  yield put(actActionBar.setSelectedOutletIds(outletIds))
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  let responseProfile = yield call(getProfile)
  yield call(getShiftSummaryAndShiftList, responseProfile, startDateFormatted, endDateFormatted)
}

export function * changeDateFlow (request) {
  yield put(setShifts([]))
  yield put(setSummary({}))
  yield put(showPageLoadingSpinner(true))
  let {startDate, endDate, isMobile} = request.payload
  yield put(hideShiftDetail(isMobile))
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(shiftSummaryRequest({start: startDateFormatted, end: endDateFormatted}))
  yield put(listShiftRequest({page: 0, start: startDateFormatted, end: endDateFormatted}))
}

/***********************************
 * API CALL
 ***********************************/
export function * shiftSummaryRequestFlow (request) {
  let query = request.payload.query
  let summary = yield call(getSummary, query)
  if (summary) {
    yield put(setSummary(summary))
  }
}

export function * listShiftRequestFlow (request) {
  yield put(showPageLoadingSpinner(true))
  let query = request.payload.query
  let shifts = yield call(getShifts, query)
  if (shifts) {
    yield put(setShifts(shifts))
    yield put(setCurrentPage(query.page))
  }
  yield put(showPageLoadingSpinner(false))
}

export function * getShiftDetailFlow (request) {
  let {query, isMobile} = request.payload
  let shiftDetails = yield call(getShiftDetails, query)
  mpReportsShifts.reportsShiftsSelect({shift: shiftDetails})
  if (shiftDetails) {
    yield put(setShiftDetails(shiftDetails))
    if (!isMobile) {
      if ($('#mk-col-left').hasClass('col-md-12')) {
        $('#mk-col-left').removeClass('col-md-12').addClass('col-md-6')
        $('#mk-col-right').removeClass('col-md-12').addClass('col-md-6')
        setTimeout(function () {
          $('#mk-col-right').show()
          $('[data-toggle="popover"]').popover()
        }, 300)
      }
    }
  }
}

export function * getMoreShiftData (params) {
  let {previousShift} = params.payload

  const {endDate, page, startDate} = params.payload.query
  const startdate = moment(startDate).format('DD/MM/YYYY')
  const enddate = moment(endDate).format('DD/MM/YYYY')

  let query = {
    page: page,
    start: startdate,
    end: enddate
  }

  try {
    yield put(action.showProgressBar())
    let shifts = yield call(getShifts, query)
    let newShifts = previousShift.concat(shifts)
    yield put(setShifts(newShifts))
    yield put(setCurrentPage(page))
  } catch (error) {

  } finally {
    yield put(action.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * hideShiftDetailFlow (request) {
  let {isMobile} = request.payload
  yield put(setShiftDetails(null))
  if (!isMobile) {
    // animation
    $('#mk-col-right').hide()
    $('#mk-col-left').removeClass('col-md-6').addClass('col-md-12')
  }
}

export function * exportShiftsFlow (request) {
  let {payload: {query, filename, outletId}} = request
  let data = yield call(exportShift, query)
  if (data && data.message === 'ok') {
    yield put(getExportedFile(filename, outletId, 'shifts'))
  }
}

export function * cancelAction (cancelledTasks, request) {
  yield cancel(...cancelledTasks)
}

export default function * reportsShiftsSaga () {
  const summaryTask = yield takeLatest(REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST, shiftSummaryRequestFlow)
  const listShiftTask = yield takeLatest(REPORTS_SHIFTS_LIST_SHIFT_REQUEST, listShiftRequestFlow)
  const pageReqTask = yield takeLatest(REPORTS_SHIFTS_PAGE_REQUEST, pageRequestFlow)
  const changeDateTask = yield takeLatest(REPORTS_SHIFTS_CHANGE_DATE, changeDateFlow)
  const exportShiftTask = yield takeLatest(REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST, exportShiftsFlow)
  const getShiftDetailTask = yield takeLatest(REPORTS_SHIFTS_DETAILS_REQUEST, getShiftDetailFlow)
  const changeOutletTask = yield takeLatest(REPORTS_SHIFTS_CHANGE_OUTLET, changeOutletShift)
  const hideShiftDetailTask = yield takeLatest(REPORTS_SHIFTS_DETAIL_HIDE, hideShiftDetailFlow)
  const moreShiftData = yield takeLatest(REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA, getMoreShiftData)

  yield takeEvery(LOGOUT, cancelAction, [
    summaryTask, listShiftTask, pageReqTask, changeOutletTask, changeDateTask, exportShiftTask,
    getShiftDetailTask, hideShiftDetailTask, moreShiftData
  ])
}



// WEBPACK FOOTER //
// ./app/sagas/reports/shifts.js